// WebSocketContext.js
import React, {createContext, useState, useEffect, useContext, useRef} from 'react';
import WebSocketService from '../../websockets/WebSocketService';
import { useSharingContext } from './SharingContext';
import {tickStorage} from "@dashboard/contexts/tickStore";

const TickContext = createContext();

export const useTickContext = () => useContext(TickContext);

export const TickProvider = ({ instrumentToken, children }) => {
    const [tick, setTick] = useState({});

    /*let closePrice = useRef(null);  // Use ref to hold closePrice without causing re-renders
    const { addClosePrice,getClosePrice } = useSharingContext();*/

    const updateTicks = (incomingTick) => {
        setTick(incomingTick);
        tickStorage.latest = {
            ...tickStorage.latest,
            [incomingTick.instrumentToken]: incomingTick
        };
    };

    const handleTickUpdate = (message) => {
        if (message.type === 'tickData') {
            const incomingTick = message.data;

            // Update single tick (for GUIInstrumentRow)
            if (incomingTick.instrumentToken === instrumentToken) {
                //console.log("incomingTick:", incomingTick);
                updateTicks(incomingTick);
            }
        }
    };

    /*const changeSubscriptionModeToDetail = async (instrumentToken) => {
        try {

            await fetch(`/gui-instruments/detailsSubscription/${instrumentToken}`,
                null,
                {withCredentials: true});

            // Update WebSocket subscriptions
            WebSocketService.unsubscribe('tickData', instrumentToken, handleTickUpdate);
            WebSocketService.subscribe('tickData', instrumentToken, handleTickUpdateInitial);
        } catch (error) {
            console.error("Failed to change subscription mode: ", error);
        }
    };
*/
    useEffect(() => {
        // Log the subscription with uniqueId
        /*if(instrumentToken===36865){
            console.log(`Subscribing to WebSocket for instrumentToken: ${instrumentToken}, uniqueId: ${uniqueId}`);
        }*/
        WebSocketService.subscribe('tickData', instrumentToken, handleTickUpdate);

        return () => {
            // Log the unsubscription with uniqueId
            /*if(instrumentToken===36865) {
                console.log(`Unsubscribing from WebSocket for instrumentToken: ${instrumentToken}, uniqueId: ${uniqueId}`);
            }*/
            WebSocketService.unsubscribe('tickData', instrumentToken, handleTickUpdate);
        };
    }, [instrumentToken]); // Add uniqueId as a dependency

    return (
        <TickContext.Provider value={{ tick }}>
            {children}
        </TickContext.Provider>
    );
};



